import { render, staticRenderFns } from "./ItemAvailabilityRep.vue?vue&type=template&id=5195e8c4&"
import script from "./ItemAvailabilityRep.vue?vue&type=script&lang=js&"
export * from "./ItemAvailabilityRep.vue?vue&type=script&lang=js&"
import style0 from "./ItemAvailabilityRep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports